import { API } from '@/config';

import {
  FILL_GLOBAL_SETTINGS_DICTIONARY, TOGGLE_MENU, TOGGLE_LOADING, TOGGLE_MODAL,
} from './mutation-types';

export default {
  toggleMenu({ commit }) {
    commit(TOGGLE_MENU);
  },

  toggleLoading({ commit }) {
    commit(TOGGLE_LOADING);
  },

  toggleModal({ commit, state }, newParams = {}) {
    const params = { ...state.modal, ...newParams };
    commit(TOGGLE_MODAL, { params });
  },

  async getGlobalDictionary({ commit }) {
    try {
      const dictionary = (await API.get('/settings/manager/dictionary')).data.data;
      commit(FILL_GLOBAL_SETTINGS_DICTIONARY, { dictionary });
    } catch (error) {
      console.log(error);
    }
  },
};
